<template>
  <div class="progress-indicator">
    <div
      v-for="(step, index) in steps"
      :key="index"
      :class="{
        current: (index + 1) === value,
        completed: (index + 1) < value,
        invalid: step.invalid,
      }"
      :data-id="index + 1"
      class="progress-indicator-step"
      @click="setStep(index + 1)"
    >
      <span class="progress-indicator-count">
        <template v-if="(index + 1) >= value && !step.invalid">{{ index + 1 }}</template>
        <template v-else>
          <SvgIcon
            :name="`components/${step.invalid ? 'warning' : 'check-small'}`"
            width="16"
            height="16"
          />
        </template>
      </span>
      <div class="progress-indicator-text">
        <span class="title">{{ step.title }}</span>
        <span
          v-if="step.subTitle"
          class="sub-title"
        >{{ step.subTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from 'vue-svgicon/dist/components/svgicon.common'

import '../../icons/components/check-small'
import '../../icons/components/warning'

export default {
  components: {
    SvgIcon,
  },

  props: {
    /**
     * Current step number, starting from 1
     */
    value: {
      type: [Number, String],
      default: 1,
    },

    /**
     * Array of steps to render in the component
     */
    steps: {
      type: Array,
      required: true,
    },
  },

  methods: {
    setStep (index) {
      this.$emit('input', index)
    },
  },
}
</script>

<style lang="scss" scoped>


.progress-indicator {
  display: flex;
  color: $gray-900;

  &-step {
    display: flex;
    flex-grow: 1;
    flex-basis: 0;
    align-items: flex-start;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    height: 50px;
    border-bottom: 1px solid $gray-200;

    &:hover {
      .progress-indicator-count {
        color: $cyan-700;
        border-color: $cyan-700;
      }

      .progress-indicator-text {
        .title {
          color: $cyan-700;
        }
      }
    }

    &.completed,
    &.current {
      border-bottom: 2px solid $cyan-700;
    }

    &.completed {
      .progress-indicator-count {
        color: #fff !important;
        background-color: $cyan-700 !important;
        border-color: $cyan-700 !important;
      }
    }

    &.current {
      .progress-indicator-count {
        color: $gray-900;
        border-color: $gray-900;
      }

      .progress-indicator-text {
        color: $gray-900;
      }
    }

    &.invalid {
      .progress-indicator-count {
        color: #fff !important;
        background-color: $red-500 !important;
        border-color: $red-500 !important;
      }

      .progress-indicator-text,
      &:hover .progress-indicator-text .title {
        color: $red-500 !important;
      }
    }
  }

  &-count {
    width: 1.5rem;
    height: 1.5rem;
    font-size: $font-size-base * 0.75;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $gray-800;
    border: 2px solid $gray-300;
    border-radius: 50%;
  }

  &-text {
    margin-left: 0.5rem;
    display: flex;
    flex-direction: column;
    color: $gray-800;

    .title {
      font-size: $font-size-sm;
    }

    .sub-title {
      color: $gray-300;
      font-size: $font-size-base * 0.75;
    }
  }
}
</style>
